import { computed, ref } from 'vue'
import { fetchFocusArea, setActionAcknowledged } from '@/api/frontlineStaffDash'
import { useFrontlineManagerDash } from '@/composables/useFrontlineManagerDash'
import { UserFocusArea } from '@/entities/frontlineStaffDash'

export type NotifyUser = (message: {
    severity: 'success' | 'error' | 'warn'
    summary: string
    detail: string
    life?: number // show duration in ms
}) => void

const { showFetchErrorMessage, setCardAsLoading } = useFrontlineManagerDash()

export const useFrontlineStaffDash = (notifyUser?: NotifyUser) => {
    // Data states
    const userFocusArea = ref<UserFocusArea>()

    // Loading states
    const loadingUserFocusArea = ref(true)

    // Error states
    const hasErrorUserFocusArea = ref(false)

    const isPageLoading = computed(() => {
        return loadingUserFocusArea.value
    })

    const fetchPageData = async (hasTeamGoal = false) => {
        if (hasTeamGoal) {
            fetchUserFocusArea()
        }
    }

    const fetchUserFocusArea = () => {
        setCardAsLoading(loadingUserFocusArea, hasErrorUserFocusArea)
        fetchFocusArea()
            .then((response) => {
                userFocusArea.value = response.data.result ?? {}
            })
            .catch((error) => {
                hasErrorUserFocusArea.value = true
                showFetchErrorMessage(error, 'focus area')
            })
            .finally(() => {
                loadingUserFocusArea.value = false
            })
    }

    const acknowledgeFocusAreaAction = (focusAreaActionId: string) => {
        setActionAcknowledged(focusAreaActionId)
            .then((response) => {
                userFocusArea.value = response.data.result
            })
            .catch((error) => {
                hasErrorUserFocusArea.value = true
                showFetchErrorMessage(error, 'focus area')
            })
    }

    return {
        userFocusArea,
        loadingUserFocusArea,
        hasErrorUserFocusArea,
        isPageLoading,
        fetchPageData,
        fetchUserFocusArea,
        acknowledgeFocusAreaAction,
    }
}
